
/* styles */
require("!!style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-25aace30!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./tab.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./tab.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-25aace30!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./tab.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/tabbar/src/tab.vue
// module id = 576
// module chunks = 0